/**
 * Returns the product subdomain from the current hostname. If the hostname is localhost, returns an empty string.
 * @returns The product subdomain
 */
export const getProductSubdomain = () => {
	const hostSegments = window.location.hostname.split('.');
	const subdomain = hostSegments[0];

	// Handle localhost specifically
	if (subdomain === 'localhost') return 'localhost';

	// If there are not enough segments for a subdomain, return empty string
	if (hostSegments.length <= 2) {
		return '';
	}

	return subdomain;
};
